export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10793.1b70b325.jpg";